module.exports = __webpack_public_path__ + "static/media/phone.041c481b.svg";